import { render, staticRenderFns } from "./ProcessDesigner.vue?vue&type=template&id=60c2cb74&scoped=true&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./ProcessDesigner.vue?vue&type=script&lang=js&"
export * from "./ProcessDesigner.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDesigner.vue?vue&type=style&index=0&id=60c2cb74&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2cb74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VFlex,VIcon,VLayout,VMenu,VRow,VSelect,VTextField,VTooltip})
